module.exports = __webpack_public_path__ + "img/pr-3.f93e935b.png";